/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IVno = Models.IVno;
    import IUser = Models.IUser;
    import IUserGroup = Models.IUserGroup;
    import Vno = Models.Vno;

    interface IVnoUserGroupRouteParamsService extends ng.route.IRouteParamsService {
        id: number;
        groupId: number;
    }

    interface IAux {
        isAdmin: boolean;
    }

    export class AdminVnoGroupController {
        public static $name: string = "adminVnoGroupController";
        public static $inject: string[] = ['vnoService',
            '$routeParams',
            'userService',
            'userGroupService',
            'ModalService',
            'aclService',
            '$q',
            '$rootScope',
        ];

        public vno: IVno;
        public webApplications: Models.IWebApplicationPermission[];
        private group: IUserGroup;
        private users: IUser[];

        private errorMessage: string;

        constructor(private vnoService: Services.VnoService,
                    private $routeParams: IVnoUserGroupRouteParamsService,
                    private userService: Services.UserService,
                    private userGroupService: Services.UserGroupService,
                    private modalService: ngModal.IModalService,
                    private aclService: Services.AclService,
                    private $q: ng.IQService,
                    private $rootScope: Services.IFlexSettings) {

            this.webApplications = Models.WebApplications.getVnoWebApplications(this.$rootScope.isMonitoringOnly);
            this.getGroupData();
        }

        public launchEditionModal(): void {
            if (this.group === undefined)
                return;
            let copy: IUserGroup = Models.UserGroup.createCopy(this.group);
            this.modalService.showModal({
                templateUrl: Controllers.AdminGroupModalController.templateURL,
                controller: Controllers.AdminGroupModalController.$name,
                inputs: {
                    title: 'Edit group',
                    group: copy,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.AdminGroupModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((group?: IUserGroup) => {
                    modalElem.hide();
                    if (group) {
                        this.vnoService.editVnoGroup(group, this.vno.id).then((group: IUserGroup) => {
                            Common.Utils.alertOnSuccess("Group saved successfully");
                            this.group = group;
                        });
                    }
                });
            });
        }

        public isCurrentUser(user: Models.IUser): boolean {
            return user.id === this.userService.getCurrentUser().id;
        }

        public saveWebAppPermissions(): void {
            let aclEntries: Models.AclEntry[] = this.webApplications.map((webApp: Models.IWebApplicationPermission, index: number) => {
                return webApp.aclEntry;
            });
            this.aclService.saveAclEntries(aclEntries).then(() => {
                if (this.users && this.users.length > 0) {
                    const usersIds: number[] = this.users
                        .map((user: Models.IUser) => Number(user.id))
                        .filter((userId: number) => Number(this.userService.getCurrentUser().id) !== userId);
                    this.userService.refreshUsers(usersIds);
                }
                Common.Utils.alertOnSuccess("Permissions saved successfully");
            });
        }

        public enableGroup(): void {
            this.group.enabled = true;
            this.userGroupService.saveGroup(this.group).then((result: Models.IUserGroup) => {
                this.group.enabled = result.enabled;
            });
        }

        public disableGroup(): void {
            this.group.enabled = false;
            this.userGroupService.saveGroup(this.group).then((result: Models.IUserGroup) => {
                this.group.enabled = result.enabled;
            });
        }

        public addUser(): void {
            let filteredUsers: Models.IUser[] = this.filteredUsers();
            this.selectUserModal(filteredUsers).then((user: IUser) => {
                if (user) {
                    this.userGroupService.addUserToGroup(user.id as number, this.group.id as number, user.organizationId)
                        .then((resp: IUser) => {
                            this.getGroupData();
                        });
                }
            });
        }

        public isOrganizationUserAclEntry(aclEntry: Models.AclEntry): boolean {
            return aclEntry && aclEntry.type === 'OrganizationUsers';
        }

        public removeUser(user: IUser): void {
            this.vnoService.removeUserFromVnoGroup(this.vno.id, this.group.id as number, user.id as number)
                .then(() => {
                    this.getGroupData();
                });
        }

        private filteredUsers(): Models.IUser[] {
            return this.vno.users.filter((user: IUser) => {
                return !this.findUser(user) && user.enabled;
            });
        }

        private findUser(user: IUser): boolean {
            return this.users ? this.users.some((groupUser: IUser) => {
                return +user.id === +groupUser.id;
            }) : false;
        }

        private selectUserModal(users: Models.IUser[]): ng.IPromise<IUser> {
            return this.modalService.showModal({
                templateUrl: Controllers.UserExistingModalController.templateURL,
                controller: Controllers.UserExistingModalController.$name,
                inputs: {
                    title: 'Select user',
                    users: users,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.UserExistingModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                return modal.close.then((result?: IUser) => {
                    modalElem.hide();
                    return result;
                });
            });

        }

        private getGroupData(): void {
            if (this.$routeParams.id && this.$routeParams.id > 0 && this.$routeParams.groupId
                && (this.$routeParams.groupId > 0 || +this.$routeParams.groupId === -1)) {
                this.vnoService.findById(this.$routeParams.id as number).then((response: IVno) => {
                    this.vno = response;
                    Vno.removeDemiurgo(this.vno);
                    let [groupFound]: Models.IUserGroup[] = this.vno.groups.filter((group: IUserGroup) => {
                        return +group.id === +this.$routeParams.groupId;
                    });
                    if (+this.$routeParams.groupId === -1) {
                        this.group = this.userGroupService.generateDefaultGroup(this.vno);
                        this.users = this.vno.users;
                        this.loadWebApplicationPermissions();
                        return;
                    }
                    if (groupFound !== undefined) {
                        this.group = groupFound;
                        this.userGroupService.getUsersInGroup(this.group.id as number, this.vno.id).then((users: IUser[]) => {
                            this.users = users;
                        });
                        this.loadWebApplicationPermissions();
                    } else {
                        this.errorMessage = `Cannot find group with id ${this.$routeParams.groupId} in organization ${this.vno.id}`;
                    }
                });
            } else {
                this.errorMessage = "Missing VNO id or Group id";
            }
        }

        private loadWebApplicationPermissions(): void {
            this.webApplications.forEach((webApplication: Models.IWebApplicationPermission, index: number) => {
                let chain: ng.IPromise<void> = this.$q.when();
                chain.then(() => {
                    this.aclService.getOrganizationUsersAclsForWebApplication(webApplication.id, this.vno.id)
                        .then((organizationUserAclEntry: Models.AclEntry) => {
                            if (this.group.isVnoDefault) {
                                webApplication.aclEntry = organizationUserAclEntry ? organizationUserAclEntry : new Models.AclEntry();
                            } else {
                                if (organizationUserAclEntry && organizationUserAclEntry.read) {
                                    webApplication.aclEntry = organizationUserAclEntry;
                                } else {
                                    this.aclService.getGrantedAuthorityAclsForWebApplication(webApplication.id, "GROUP_" + this.group.id)
                                        .then((grantedAuthorityAclEntry: Models.AclEntry) => {
                                            webApplication.aclEntry = grantedAuthorityAclEntry ? 
                                                                      grantedAuthorityAclEntry : new Models.AclEntry();
                                        });
                                }
                            }
                        });
                });
            });
        }
    }
}
